import { render, staticRenderFns } from "./largeScreen.vue?vue&type=template&id=148eee92&scoped=true"
import script from "./largeScreen.vue?vue&type=script&lang=js"
export * from "./largeScreen.vue?vue&type=script&lang=js"
import style0 from "./largeScreen.vue?vue&type=style&index=0&id=148eee92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148eee92",
  null
  
)

export default component.exports